import { Button, Skeleton, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import {useLocation, useNavigate} from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

const ConsultingAreas = ({ areas, loading }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const tablet = useMediaQuery(theme => theme.breakpoints.down('md'));

    return (
        <div>
            {loading ?
                <Skeleton animation="wave" type="rectangle" height={360} />
                : areas ?
                areas.map((area, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: index % 2 === 0 ? 'row' : 'row-reverse',
                            flexWrap: 'wrap',
                            '@media (max-width: 900px)': {
                                flexDirection: 'column',
                            },
                        }}
                    >
                        <Box
                            sx={{
                                backgroundImage: `url(${area.image})`,
                                width: '50%',
                                height: 'auto',
                                maxHeight: '500px',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                '@media (max-width: 900px)': {
                                    width: '100%',
                                    height: '200px',
                                },
                            }}
                        />
                        <Box
                            sx={{
                                width: '50%',
                                '@media (max-width: 900px)': {
                                    width: '100%',
                                },
                                backgroundColor: index % 2 === 0 ? 'rgb(240, 240, 240)' : '#ffffff',
                                padding: index % 2 === 0 ? tablet ? '20px 24px 40px 5%!important' : '70px 5% 90px 24px!important' : tablet ? '20px 24px 40px 5%!important' : '70px 5% 90px 24px!important',
                            }}
                        >
                            <Box
                                sx={{
                                    maxWidth: 'calc(700px - 9%)',
                                    float: index % 2 === 0 ? 'left' : 'right',
                                }}
                            >
                                <Typography
                                    variant="h3"
                                    sx={{
                                        fontSize: '1.3rem',
                                        fontWeight: '800',
                                        color: '#265DA5',
                                        margin: '20px 0',
                                    }}
                                >
                                    {area.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: '1rem',
                                        fontWeight: '400',
                                        color: '#000000',
                                    }}
                                >
                                    {area.text}
                                </Typography>
                                <Button
                                    sx={{
                                        backgroundColor:'#265DA5',
                                        color:'#fff',
                                        borderRadius:'2rem',
                                        fontSize:'1rem',
                                        p:'0.5rem 1rem',
                                        marginTop: '1em',
                                        cursor:'pointer',
                                        '&:hover':{
                                            backgroundColor:'#E9531C',
                                        },
                                    }}
                                    component={RouterLink}
                                    to={area.consulting_page}
                                >
                                    {area.button_text}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                ))
            : <p>No consulting areas found</p>
            }
        </div>
    );
}

export default ConsultingAreas;
